import { produce } from 'immer';
import { extractError } from 'app/lib/error/errorMappings.js';
import { LOAD_PROJECT } from 'app/store/projects/types.js';
import {
    CLOSE_FILTER,
    CREATE_FILTER,
    EDIT_FILTER,
    OPEN_FILTER,
    PREVIEW_FILTER,
    SET_CURRENT_PARAMS,
    SET_FORM_VALID,
    UPDATE_FILTER
} from './types.js';

export const INITIAL_STATE = {
    isFilterOpen: false,
    currentEntityId: null,
    isProcessing: false,
    isSaving: false,
    error: null,
    currentParams: {},
    isValid: true,
    hasExplicitPreview: false
};

export const filterReducer = produce((draft, action) => {
    switch (action.type) {
        case OPEN_FILTER:
            draft.isFilterOpen = true;
            if (action.payload?.entityId) {
                draft.currentEntityId = action.payload.entityId;
            }
            break;

        case CLOSE_FILTER:
            draft.isFilterOpen = false;
            draft.currentEntityId = null;
            draft.error = null;
            draft.isProcessing = false;
            draft.isSaving = false;
            draft.currentParams = {};
            draft.hasExplicitPreview = false;
            break;

        case PREVIEW_FILTER:
            draft.hasExplicitPreview = true;
            break;

        case EDIT_FILTER:
            draft.currentEntityId = action.payload.entityId;
            break;

        case SET_CURRENT_PARAMS:
            draft.currentParams = action.payload.params;
            break;

        case SET_FORM_VALID:
            draft.isValid = action.payload.isValid;
            break;

        case CREATE_FILTER.STARTED:
        case UPDATE_FILTER.STARTED:
            draft.isSaving = true;
            draft.isProcessing = true;
            draft.error = null;
            if (!action.meta?.keepOpen) {
                draft.isFilterOpen = false;
                draft.currentEntityId = null;
                draft.currentParams = {};
            }
            break;

        case CREATE_FILTER.SUCCEEDED:
        case UPDATE_FILTER.SUCCEEDED:
            break;

        case CREATE_FILTER.REJECTED:
        case CREATE_FILTER.FAILED:
        case UPDATE_FILTER.REJECTED:
        case UPDATE_FILTER.FAILED:
            draft.error = extractError(action.payload);
            break;

        case CREATE_FILTER.ENDED:
        case UPDATE_FILTER.ENDED:
            draft.isProcessing = false;
            draft.isSaving = false;
            break;

        case LOAD_PROJECT.STARTED:
            if (!draft.isFilterOpen) {
                draft.currentEntityId = null;
            }
            break;

        default:
            break;
    }
}, INITIAL_STATE);
